module.exports = __webpack_public_path__ + "img/pchomeservice.2d0d4d85.svg";